<template>
  <div class="contact-page">
    <!-- 顶部横幅 -->
    <section class="banner-section">
      <img src="@/assets/pic/contact-ban.jpg" alt="联系我们" class="banner-img" />
      <div class="banner-overlay"></div>
      <div class="banner-content">
        <h1 class="banner-title">{{ $i18n.t('contact.bannerTitle') }}</h1>
        <p class="banner-subtitle">{{ $i18n.t('contact.bannerDesc') }}</p>
      </div>
    </section>

    <!-- 主内容区域 -->
    <section class="main-section">
      <div class="container">
        <!-- 区域标题 -->
        <div class="section-header scroll-animate fade-up" data-delay="0">
          <h2 class="secTitle">{{ $i18n.t('contact.sectionTitle') }}</h2>
          <span>{{ $i18n.t('contact.sectionSub') }}</span>
        </div>

        <!-- 电子邮件 + 公司地址：卡片横排 -->
        <div class="info-cards">
          <div
            v-for="(item, index) in contactItems"
            :key="index"
            class="info-card scroll-animate fade-up"
            :data-delay="(index + 1) * 150"
          >
            <div class="info-icon-wrap">
              <img :src="item.icon" :alt="item.titleKey" class="info-svg" />
            </div>
            <h3>{{ $i18n.t(item.titleKey) }}</h3>
            <p>{{ $i18n.t(item.valueKey) }}</p>
            <p v-if="item.valueKey2">{{ $i18n.t(item.valueKey2) }}</p>
          </div>
        </div>

        <!-- 公司位置：地图区域 -->
        <div class="map-section scroll-animate fade-up" data-delay="100">
          <div class="map-card">
            <h3>{{ $i18n.t('contact.mapTitle') }}</h3>
            <p class="map-desc">{{ $i18n.t('contact.mapDesc') }}</p>
            <div class="map-wrapper scroll-animate fade-up" data-delay="200">
              <img src="@/assets/pic/map.jpg" alt="公司位置地图" class="map-img" />
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup>
import { useScrollAnimation } from '../composables/useScrollAnimation'
useScrollAnimation()

const contactItems = [
  {
    icon: new URL('@/assets/pic/contact-icon1-4.svg', import.meta.url).href,
    titleKey: 'contact.emailTitle',
    valueKey: 'contact.emailValue',
  },
  {
    icon: new URL('@/assets/pic/contact-icon1-1.svg', import.meta.url).href,
    titleKey: 'contact.addressTitle',
    valueKey: 'contact.addressValueCN',
    valueKey2: 'contact.addressValueEN',
  },
]
</script>

<style scoped>
.contact-page {
  min-height: 100vh;
}

/* ====== 横幅区域 ====== */
.banner-section {
  position: relative;
  width: 100%;
  overflow: hidden;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(to right, rgba(0, 20, 40, 0.85) 0%, rgba(0, 20, 40, 0.7) 60%, transparent 100%);
  pointer-events: none;
  z-index: 1;
}

.banner-img {
  width: 100%;
  /* height: 25rem; */
  object-fit: cover;
  display: block;
}

.banner-content {
  position: absolute;
  top: 50%;
  left: 12rem;
  transform: translateY(-50%);
  z-index: 2;
}

.banner-title {
  font-size: 3rem;
  font-weight: bold;
  color: #fff;
  margin-bottom: 0.75rem;
  letter-spacing: 0.125rem;
}

.banner-subtitle {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.8);
  line-height: 1.6;
  max-width: 31.25rem;
}

/* ====== 容器 ====== */
.container {
  max-width: 87rem;
  margin: 0 auto;
  padding: 0 1.25rem;
}

/* ====== 区域标题 - 居中+短线 ====== */
.section-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 3rem;
}

.secTitle {
  font-size: 1.75rem;
  font-weight: bold;
  color: #1a3a5c;
  display: inline-block;
  position: relative;
  padding-bottom: 1.1rem;
  margin-bottom: 0;
}

.secTitle::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 3rem;
  height: 0.1875rem;
  background-color: #4779B5;
  border-radius: 0.0625rem;
}

.section-header span {
  font-size: 1rem;
  color: #999;
  letter-spacing: 0.1875rem;
  margin-top: 0.625rem;
}

/* ====== 主内容区域 ====== */
.main-section {
  padding: 5rem 0;
  background-color: #fff;
}

/* ====== 介绍段落 ====== */
.intro-block {
  border-left: 0.1875rem solid #4779B5;
  padding-left: 1.875rem;
  margin-bottom: 3rem;
}

.intro-block p {
  font-size: 1.2rem;
  line-height: 2;
  color: #555;
  text-align: justify;
}

/* ====== 信息卡片（横排卡片样式） ====== */
.info-cards {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 2.5rem;
  margin-bottom: 3rem;
}

.info-card {
  display: flex;
  flex-direction: column;
  padding: 2rem 1.875rem;
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.08), 0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
}

.info-card:hover {
  transform: translateY(-0.1875rem);
  box-shadow: 0 0.625rem 1.5rem rgba(71, 121, 181, 0.12);
}

/* 圆形图标背景 */
.info-icon-wrap {
  width: 3.125rem;
  height: 3.125rem;
  background-color: rgba(71, 121, 181, 0.08);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 1.25rem;
}

.info-svg {
  width: 1.5rem;
  height: 1.5rem;
}

.info-card h3 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.75rem;
}

.info-card p {
  font-size: 1.2rem;
  line-height: 1.7;
  color: #555;
}

.info-card p + p {
  margin-top: 0.375rem;
}

/* ====== 地图区域（卡片样式与info-card一致） ====== */
.map-section {
  margin-top: 4rem;
}

.map-card {
  padding: 2rem 1.875rem;
  background: #fff;
  border-radius: 0.625rem;
  box-shadow: 0 0.25rem 0.375rem -0.0625rem rgba(0, 0, 0, 0.08), 0 0.125rem 0.25rem -0.125rem rgba(0, 0, 0, 0.05);
}

.map-card h3 {
  font-size: 1.4rem;
  font-weight: bold;
  color: #1a3a5c;
  margin-bottom: 0.625rem;
}

.map-desc {
  font-size: 1.2rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 1.25rem;
}

.map-wrapper {
  width: 100%;
  border-radius: 0.5rem;
  overflow: hidden;
}

.map-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ====== 响应式设计 ====== */
@media (max-width: 48rem) {
  .banner-section {
    height: 17.5rem;
  }

  .banner-img {
    height: 17.5rem;
  }

  .banner-content {
    left: 1.875rem;
  }

  .banner-title {
    font-size: 1.5rem;
  }

  .banner-subtitle {
    font-size: 1rem;
  }

  .main-section {
    padding: 3.125rem 0;
  }

  .info-cards {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
}

@media (max-width: 30rem) {
  .banner-title {
    font-size: 1.5rem;
  }
}
</style>
